<template>
  <ul
    class="eds-tabset m-0 overflow-auto"
    role="tablist"
    :class="[tabsHeaderClass]"
    :style="tabsHeaderStyle"
  >
    <slot />
  </ul>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  export default defineComponent({
    name: 'TabsHeader',
    props: {
      tabsHeaderClass: {
        type: String,
        required: false,
        default: '',
      },
      tabsHeaderStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>
